<template>
    <button
            :class="{
            ['bg-'+color]: !flat && !disabled && !outlined,
            'bg-gray-300': disabled && !icon,
            'text-back': !dark,
            'text-white': dark,
            'rounded-full': !tile,
            border: outlined && !flat && !fab && !icon,
            ['border-'+color]: outlined && color !== 'transparent',
            'border-black': outlined && color === 'transparent',
            'p-1': !noPadding && !fab,
            'shadow-xl': fab,
            'w-full': block
        }"
            :style="{
            width: !fab ? parseInt(width) > 50 ? parse(width) : '' : parse(size),
            'min-height': !fab ? parse(height) : parse(size) ,
            'cursor': disabled ? 'default' : 'pointer'
        }"
            class="focus:outline-none relative overflow-hidden"
            v-on:mousedown.left="clicked($event)"
    >
        <row :justify="(fab || icon) ? 'center' : 'space-between'" class="uppercase flex w-full items-center button-content z-10">
            <slot v-if="!loading">Button</slot>
            <div class="w-full h-full flex items-center justify-center" v-if="loading">
                <loader :show-text="false" class="my-3"></loader>
            </div>
        </row>
    </button>
</template>

<script>
    export default {
        name: "Btn",
        props: {
            fab: {type: Boolean, default: false},
            block: {type: Boolean, default: false},
            tile: {type: Boolean, default: false},
            color: {type: String, default: 'transparent'},
            outlined: {type: Boolean, default: false},
            width: {type: [Number, String], default: '50px'},
            height: {type: [Number, String], default: '50px'},
            dark: {type: Boolean, default: false},
            flat: {type: Boolean, default: false},
            icon: {type: Boolean, default: false},
            disabled: {type: Boolean, default: false},
            size: {type: [Number, String], default: '50'},
            ripple: {type: Boolean, default: true},
            noPadding: {type: Boolean, default: false},
            loading: {type: Boolean, default: false}
        },
        components: {
            row: () => import('@/components/display/Row.vue'),
            loader: () => import('@/components/display/Loader.vue')
        },
        methods: {
            parse(value) {
                return value.includes('%') ? value : (value.replace('px', '') + 'px');
            },
            clicked(event) {
                if (!this.disabled && !this.loading) {
                    this.$emit('click');
                    if (this.ripple) {
                        let x = event.offsetX,
                            y = event.offsetY,
                            ripple = document.createElement('span');
                        ripple.style.left = x + 'px';
                        ripple.style.top = y + 'px';
                        ripple.style.position = 'absolute';
                        ripple.style.opacity = '0';
                        ripple.style.width = '3px';
                        ripple.style.height = '3px';
                        ripple.style.borderRadius = '50%';
                        ripple.classList.add('z-0');
                        ripple.style.backgroundColor = 'rgba(0,0,0,0.3)';
                        this.$el.appendChild(ripple);
                        setTimeout(() => {
                            ripple.style.transition = 'all';
                            ripple.style.transitionDuration = '0.8s';
                            ripple.style.transform = 'scale(100)';
                            ripple.style.opacity = '1';
                            setTimeout(() => {
                                ripple.style.transition = 'all';
                                ripple.style.transitionDuration = '0.2s';
                                ripple.style.opacity = '0';
                                setTimeout(() => {
                                    ripple.remove();
                                }, 100)
                            }, 400);
                        }, 0)
                    }
                }
            }
        },
        mounted() {
            //TODO: Get rid of timeout
            // setTimeout(() => {
            //     let container = this.$el.querySelector('.button-content');
            //     [...container.childNodes].forEach(el => {
            //         if (el.nodeName === '#text') {
            //             if (!el.previousSibling) {
            //                 if (!this.noPadding) {
            //                     container.style.paddingLeft = '0.75rem';
            //                 }
            //             } else {
            //                 if (el.previousSibling.nodeName === 'svg') {
            //                     if (!this.noPadding) {
            //                         container.style.paddingLeft = '0.75rem';
            //                     }
            //                 }
            //                 try {
            //                     el.previousSibling.style.marginRight = '0.75rem'
            //                 } catch(e) {
            //                     console.log(e, this.$el);
            //                 }
            //             }
            //             if (!el.nextSibling) {
            //                 if (!this.noPadding) {
            //                     container.style.paddingRight = '0.75rem';
            //                 }
            //             } else {
            //                 if (el.nextSibling.nodeName === 'svg') {
            //                     if (!this.noPadding) {
            //                         container.style.paddingRight = '0.75rem';
            //                     }
            //                 }
            //                 el.nextSibling.style.marginLeft = '0.75rem'
            //             }
            //         }
            //     });
            // }, 500);
        }
    }
</script>

<style scoped>
    *:focus {
        -webkit-tap-highlight-color: transparent;
        -ms-touch-action: manipulation;
        touch-action: manipulation;
    }

    *:active {
        -webkit-tap-highlight-color: transparent;
        -ms-touch-action: manipulation;
        touch-action: manipulation;
    }
</style>